import { featureEnabled, User } from '@fusion/auth';

export type AccessRuleFn = (user: User) => boolean;

export const subscriptionV2Available: AccessRuleFn = user => user && !!user?.subscription;

export const subscriptionFeatureEnabled =
  (productName: string, featureName: string): AccessRuleFn =>
  user => {
    if (!user || !user.subscription) {
      return false;
    }

    const planFeature = user.subscription.plan.features.find(
      (feature: any) => feature.productName === productName && feature.featureName === featureName,
    );

    if (!planFeature) {
      return false;
    }

    if (!planFeature.availableInSubscriptionStatuses.includes(user.subscription.status)) {
      return false;
    }

    return true;
  };

export const organisationFeatureFlagEnabled = (featureFlag: string) => (user: User) =>
  user?.organisation?.details?.[featureFlag] === true;

export const academicConnectPilotEnabled = () => featureEnabled('academicConnectPilot');
